/// <amd-module name="Build/Admin/Pool/Stores/SecurityStore" />
import { Store } from "VSS/Reflux/Store";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface ISecurityStoreState {
    hasManageQueuePermission: boolean;
    hasManagePoolPermission: boolean;
    hasManageAllQueuesPermission: boolean;
    hasManageAllPoolsPermission: boolean;
    pipelinesAuthorizedForQueue: boolean;
    status: StoreStatus;
}

export class SecurityStore extends Store {
    public state: ISecurityStoreState = {
        hasManageQueuePermission: false,
        hasManagePoolPermission: false,
        hasManageAllQueuesPermission: false,
        hasManageAllPoolsPermission: false,
        pipelinesAuthorizedForQueue: false,
        status: StoreStatus.None
    };

    constructor() {
        super("SecurityStoreChanged");
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            ...this.state,
            status
        };

        this.emitChanged();
    }

    public updateManageQueuePermission = (hasManageQueuePermission: boolean): void => {
        this.state = {
            ...this.state,
            hasManageQueuePermission
        };

        this.emitChanged();
    }

    public updateManagePoolPermission = (hasManagePoolPermission: boolean): void => {
        this.state = {
            ...this.state,
            hasManagePoolPermission
        };

        this.emitChanged();
    }

    public updateManageAllQueuesPermission = (hasManageAllQueuesPermission: boolean): void => {
        this.state = {
            ...this.state,
            hasManageAllQueuesPermission
        };

        this.emitChanged();
    }

    public updateManageAllPoolsPermission = (hasManageAllPoolsPermission: boolean): void => {
        this.state = {
            ...this.state,
            hasManageAllPoolsPermission
        };

        this.emitChanged();
    }

    public updatePipelinesAuthorizedForQueue = (pipelinesAuthorizedForQueue: boolean): void => {
        this.state = {
            ...this.state,
            pipelinesAuthorizedForQueue,
            status: StoreStatus.Loaded
        };

        this.emitChanged();
    }
}
